import { WORK_CORRECT_CAUSE_NAMES, WorkView } from "@project/shared-types";
import { InfoCardJob } from "../../job/ui/InfoCardJob/InfoCardJob";




export const CorrectView = ({
    work
}: {
    work?: WorkView
}) => {
    if (!work || !work.correct) return null;
    return (
        <>
            <InfoCardJob
                title="Исправление:"
                text={WORK_CORRECT_CAUSE_NAMES[work.correct.cause]}
            />
            <InfoCardJob
                title="Ваш комментарий:"
                text={work.correct.client_comment}
                column
            />
        </>
    )
}